import { RootState } from '@/App/store';

export const selectLanguages = (state: RootState) => state.i18n.languages;
